<template>
  <div>
    <b-form-checkbox
      value="1"
      unchecked-value="2"
      v-model="form.tds_isActive"
      switch
      class="table-status-icon"
      @change.native="popupActive = true"
    />

    <div class="demo-alignment">
      <vs-popup
        :id="'popmodalS' + params.data.tds_id"
        :button-close-hidden="true"
        class="holamundo p-2"
        title="TDS Status"
        :active.sync="popupActive"
      >
        <div class="text-center">
          <h5>Do you want to change Status ?</h5>
          <div class="vx-row mt-5">
            <div class="vx-col mx-auto">
              <vs-button
                color="success"
                type="filled"
                @click="onChangeCheckbox()"
                class="mr-3"
              >
                Yes
              </vs-button>

              <vs-button
                color="danger"
                type="filled"
                @click.native="privStatus()"
              >
                No
              </vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MasterService from "@/services/MasterService.js";

export default Vue.extend({
  data() {
    return {
      params: null,
      popupActive: false,
      form: {
        tds_isActive: "1",
      },
      copy_tds_isActive: null,
    };
  },
  beforeMount() {
    this.form = this.params.data;
    this.copy_tds_isActive = this.form.tds_isActive;
  },
  beforeDestroy() {
    let _id = document.getElementById("popmodalS" + this.params.data.tds_id);
    _id.setAttribute("style", "display: none;");
  },
  methods: {
    onChangeCheckbox: function() {
      this.$vs.loading();
      let id = this.params.data.tds_id;
      let payload = {
        tds_name: this.params.data.tds_name,
        tds_isActive: this.form.tds_isActive,
        tds_percentage: this.params.data.tds_percentage,
      };

      MasterService.updateTDS(payload, id)
        .then((response) => {
          this.$vs.loading.close();
          const { data } = response;
          if (data.Status == true) {
            this.$vs.notify({
              title: "Updated!",
              text: data.Message,

              iconPack: "feather",
              icon: "check_box",
              color: "success",
            });
            this.popupActive = false;
          } else {
            this.$vs.loading.close();
            console.log("data :", data);
            this.$vs.notify({
              title: "Error!",
              text: data.Message,

              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    privStatus: function() {
      this.popupActive = false;
      this.form.tds_isActive = this.copy_tds_isActive;
    },
  },
});
</script>
